<template>
  <v-container>
    <div class="container">
      <h3>维修工程部 驻外时间表</h3>
      <div v-for="group in allgroups" :key="group.stationName">
        <div class="text-subtitle-2">
          {{ group.stationName }}
        </div>
        <div class="basecontainer">
          <table class="text-caption" cellpadding="0" cellspacing="0" style="table-layout: fixed">
            <tr class="stanpcontainer">-</tr>
            <tr v-for="j in group.chaines.length" :key="j" class="stanpcontainer">
              <td>
                <span class="lastnumber rounded"> {{ (j) | toFix(2) }} </span>
              </td>
            </tr>
          </table>
          <div class="groupstyle" ref="groupdivs">
            <table class="text-caption" cellpadding="0" cellspacing="0" style="table-layout: fixed">
              <tr class="stanpcontainer">
                <div v-for="(timeline, i) in group.monthIter" :key="i" :style="{ width: timeline.days * 1.5 + 'px' }"
                  class="labelblock" @click="timelineclick(timeline)">
                  {{ timeline.year }}-{{ timeline.month }}
                </div>
              </tr>
              <tr v-for="(chain, j) in group.chaines" :key="j" class="stanpcontainer stanpstyle">
                <div v-for="(stanpkey, k) in chain.values.map((a) =>
                  stanpCtx(a,group)
                )" :key="k" class="text-no-wrap stanpblock px-0 mr-0" :class="stanpclass(stanpkey, k)"
                  :style="stanpkey.stanptimespend + stanpkey.marginleft" @click="stanpkeyclick(stanpkey)">
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{ stanpkey.namestr }}
                      </span>
                    </template>
                    <div>
                      <table>
                        <tr>
                          姓名：{{
                            stanpkey.name
                          }}
                        </tr>
                        <tr>
                          站点：{{
                            group.stationName
                          }}
                        </tr>
                        <tr>
                          隶属：{{
                            stanpkey.belong
                          }}
                        </tr>
                        <tr>
                          岗位：{{
                            stanpkey.grade
                          }}
                        </tr>
                        <tr>
                          驻外时间：{{
                            stanpkey.cmddate | shorttime
                          }}
                        </tr>
                        <tr>
                          撤离时间：{{
                            stanpkey.levdate | shorttime
                          }}
                        </tr>
                      </table>
                    </div>
                  </v-tooltip>
                </div>
              </tr>
            </table>
          </div>
          <table class="text-caption" cellpadding="0" cellspacing="0" style="table-layout: fixed">
            <tr class="stanpcontainer">.</tr>
            <tr v-for="j in group.chaines.length" :key="j" class="stanpcontainer">
              <td>
                <span class="lastnumber rounded"> {{ j | toFix(2) }} </span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { ax_get } from "@/js/axreqs.js";

function getYearMonth(adate){
  return [adate.getFullYear(),adate.getMonth()+1]
}

function* MIter(group) {
  const monthScreen=21;
  let ed = new Date();
  let id = new Date(group.firstTime);
  id.setDate(1);
  let [id_year,id_month]=getYearMonth(id);
  let [ed_year,ed_month]=getYearMonth(ed);
  const deltaMonth=ed_year*12+ed_month-id_year*12-id_month;
  if(deltaMonth<monthScreen){
    // id.setMonth(deltaMonth-monthScreen);
  }

  while (id <= ed) {
    yield {
      year: String(id_year).toString().substring(2, 4),
      month: id_month,
      days: new Date(id_year, id_month, 0).getDate(),
    };
    id.setMonth(id_month);
    [id_year,id_month]=getYearMonth(id);
  }
}

function cauculaiteGroupParams(groups) {
  for (let group of groups) {
    group.monthIter = MIter(group);
    for (let chain of group.chaines) {
      let chainvalues = chain.values;
      for (let index = 0; index < chainvalues.length - 1; index++) {
        let next = chainvalues[index + 1];
        let current = chainvalues[index];
        next.from = current;
        current.to = next;
      }
    }
  }
}

export default {
  name: "plt",

  components: {},

  data: () => ({
    allgroups: [],
    needScroll: 0,
  }),
  computer: {},
  methods: {
    stanpclass(stanpkey, k) {
      if (stanpkey.classis) {
        return k % 2 == 0 ? "primary" : "blue";
      } else {
        return "green";
      }
    },
    stanpCtx(stanp,group) {
      let cdt = new Date(stanp.cmddate).getTime();
      let classis = false;
      let mlv = 0;
      let spare = 0;
      if (stanp.from) {
        let prdt = new Date(stanp.from.levdate).getTime();
        let deltDay = (cdt - prdt) / 1000 / 3600 / 24;
        mlv+= deltDay * 1.5;
      } else {
        let fd = new Date(group.firstTime);
        let fdt = new Date(fd.getFullYear(), fd.getMonth(), 1).getTime();
        let deltDay = (cdt - fdt) / 1000 / 3600 / 24;
        mlv+= deltDay * 1.5;
      }

      if (stanp.dayspare) {
        spare = stanp.dayspare * 1.5;
        classis = true;
      } else {
        let ld = new Date();
        // let lastday = new Date(ld.getFullYear(), ld.getMonth(), 0).getDate();
        // ld.setDate(lastday);
        spare = ((ld.getTime() - cdt) / 1000 / 3600 / 24) * 1.5;
      }

      let namestr = stanp.name;
      //一个中文字符12.4px
      //一个\u00a0 3.37px
      const SPACECOUNT = 120;
      const spacestr = "\u00a0".repeat(SPACECOUNT);
      const groupstr = spacestr + stanp.name;

      const namepx = namestr.length * 12.4;
      // const spacerpx = 3.37 * SPACECOUNT;
      const spacerpx = 3.95 * SPACECOUNT;
      const grouppx = spacerpx + namepx;

      let allpx = namepx;
      let condition = true;
      while (condition) {
        allpx += grouppx;
        if (allpx > spare) {
          break;
        }
        namestr += groupstr;
      }

      //   let repeatcount = (spare - namepx) / namestrlen;
      // namestr += "\u00a0".repeat((spare - allpx) / 3.37);
      //     let spacecount = (spare - namepx) / 3.37;
      //     if (spacecount > 0) {
      //       namestr += "\u00a0".repeat(spacecount);
      //     }
      //   }

      return {
        //
        namestr,
        name: stanp.name,
        grade: stanp.grade,
        cmddate: stanp.cmddate,
        levdate: stanp.levdate || "驻外中",
        belong: stanp.belong,
        stanptimespend: `;width:${spare}px`,
        marginleft: `;margin-left:${mlv}px`,
        classis,
        spare, //tododel
      };
    },
    timelineclick(timeline) {
      console.log(timeline);
    },
    stanpkeyclick(stanpkey) {
      console.log(stanpkey);
    },
  },
  filters: {
    shorttime(timestr) {
      let d = new Date(timestr);
      if (isNaN(d.getTime())) {
        return timestr;
      } else {
        return d.toLocaleDateString();
      }
    },
    toFix(num, how) {
      return String(num).padStart(how, "0");
    },
  },
  created() {
    ax_get(
      "/pailietu",
      {},
      (res) => {
        let data = res.data || res;

        data.rowDatas.forEach((groups) => {
          let onCounts = groups.chaines.reduce(
            (t, c) => !c.spendtime.end * 1 + t,
            0
          );
          groups.soredNumber = onCounts * 100 + groups.chaines.length;
          // this.needScroll += onCounts > 0;
          this.needScroll += groups.hasCurrent;
        });
        this.allgroups = data.rowDatas.sort(
          (a, b) => b.soredNumber - a.soredNumber
        );
        cauculaiteGroupParams(this.allgroups);

        this.$nextTick(() => {
          let divs = this.$refs.groupdivs;

          //有驻外人员的站点数量+1=滚动到最右侧的默认组

          for (let i = 0; i < this.needScroll; i++) {
            divs[i].scroll(divs[i].scrollWidth, 0);
          }
        });
      },
      "https://www.jojogos.ltd:5050"
    );
  },
  mounted() { },
};
</script>
<style scoped>
.container {
  /*overflow: scroll;*/
  width: 1100px;
}

.groupstyle {
  overflow-x: auto;
  width: 1000px;
  display: flex;
}

.stanpcontainer {
  display: flex;
  padding-bottom: 1px;
}

.stanpstyle{
  border-bottom: dashed 1px lightgray;
}

.labelblock {
  border-right: 1.5px dashed gray;
  border-top: 1.5px dashed gray;
}

.stanpblock {
  border-right: 1.5px dashed gray;
}

.lastnumber {
  /* background-color: lightgray; */
  color: darkblue;
  font-size: 14px;
  background-color: rgb(143, 189, 190);
  /* position: fixed; */
}

.basecontainer {
  display: flex;
}
</style>
